export default __webpack_public_path__ + "media/images/gallery/21-7fbb8615026aa8af04673f04e913dcdf.jpg";